const BASE_URL = 'https://eonet.gsfc.nasa.gov/api/v3';

/**
 * Fetch wildfire events from NASA EONET v3.
 * @param {number} days   - number of days back to query (1–365)
 * @param {string} status - 'all' | 'open' | 'closed'
 * @returns {Promise<Array>} array of event objects
 */
export async function fetchWildfires(days = 30, status = 'all') {
  let url = `${BASE_URL}/events?category=wildfires&days=${days}&limit=500`;
  if (status === 'open') url += '&status=open';
  if (status === 'closed') url += '&status=closed';

  const res = await fetch(url);
  if (!res.ok) throw new Error(`NASA EONET returned ${res.status}`);

  const data = await res.json();
  return (data.events || []).filter(
    e => e.geometry && e.geometry.length > 0
  );
}

/**
 * Get the most recent coordinate pair from an event.
 * @param {Object} event - EONET event object
 * @returns {[number, number] | null} [lat, lng] or null
 */
export function getLatLng(event) {
  if (!event.geometry || event.geometry.length === 0) return null;
  const geo = event.geometry[event.geometry.length - 1];
  if (!geo?.coordinates) return null;
  return [geo.coordinates[1], geo.coordinates[0]];
}

/**
 * Get the most recent date string from an event.
 * @param {Object} event
 * @returns {string}
 */
export function getEventDate(event) {
  if (!event.geometry || event.geometry.length === 0) return '';
  const geo = event.geometry[event.geometry.length - 1];
  if (!geo?.date) return '';
  return new Date(geo.date).toLocaleDateString(undefined, {
    year: 'numeric', month: 'short', day: 'numeric'
  });
}

/**
 * Determine if an event is still active (open).
 * @param {Object} event
 * @returns {boolean}
 */
export function isOpen(event) {
  return !event.closed;
}
